import { render, staticRenderFns } from "./abandonDeviceCallthepolice.vue?vue&type=template&id=5c15e3e6&"
import script from "./abandonDeviceCallthepolice.vue?vue&type=script&lang=js&"
export * from "./abandonDeviceCallthepolice.vue?vue&type=script&lang=js&"
import style0 from "./abandonDeviceCallthepolice.vue?vue&type=style&index=0&id=5c15e3e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports